import MdxContent from "../../help/inspection-records.mdx";

export function InspectionRecordsPageHelpPage() {
  return <MdxContent />;
}
